export enum StatusAPI {
  initial = 0,
  calling = 1,
  success = 2,
  failure = 3,
}
